<form #addForm="ngForm" (ngSubmit)="save(newValue)">
  <table class="table table-striped table-sm">
    <thead *ngIf="showHeader" class="thead-default">
    <tr>
      <th *ngIf="showCount">#</th>
      <th *ngFor="let header of headers; let i = index" scope="col">
        <div class="d-flex align-items-center">
          <span (click)="sortHeader(i)">{{ header?.name }}</span>
          <ng-container *ngIf="header.sortable">
            <ng-container *ngIf="sorting !== i || sorting === -1">
              <button type="button" class="btn btn-sm d-print-none" (click)="sortHeader(i)">
                <span aria-hidden="true" class="fa fa-fw fa-sort">&nbsp;</span>
              </button>
            </ng-container>
            <ng-container *ngIf="sorting === i">
              <button type="button" class="btn btn-sm d-print-none" (click)="sortHeader(i)">
                <span *ngIf="header.sortOrder === SortDirection.Ascending" aria-hidden="true"
                      class="fa fa-fw fa-sort-up">&nbsp;</span>
                <span *ngIf="header.sortOrder === SortDirection.Descending" aria-hidden="true"
                      class="fa fa-fw fa-sort-down">&nbsp;</span>
              </button>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="header.filterable">
            <div class="ms-auto d-print-none" ngbDropdown autoClose="autoClose" placement="bottom-right">
              <button type="button" class="btn btn-sm btn-link" ngbDropdownToggle>
                <i aria-hidden="true" class="fa fa-fw fa-filter"></i>
              </button>
              <div ngbDropdownMenu>
                <button type="button" (click)="toggleOmit(header.value,d)"
                        *ngFor="let d of data | distinct : header.value"
                        class="dropdown-item">
                  <i *ngIf="!isOmitted(header.value,d)" aria-hidden="true" class="fa fa-fw fa-square-o"></i>
                  <i *ngIf="isOmitted(header.value,d)" aria-hidden="true" class="fa fa-fw fa-check-square-o"></i>
                  {{ d }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </th>
      <th *ngIf="showOptions()" class="options d-print-none">Options</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let d of data | arrayFilter : omittedValues; let i = index">
      <tr [class]="color(d)" [ngClass]="{'row-disabled':disableRow(i)}">
        <th *ngIf="showCount" scope="row">{{ i + 1 }}</th>
        <td *ngFor="let h of headers">
          <ng-container *ngIf="!editRow(i)">
            <ng-container *ngIf="h.dataType === 4">
              <p class="text-center">
                <span class="fa"
                      [ngClass]="{'fa-check-square-o':d[h.value], 'fa-square-o':!d[h.value]}">&nbsp;</span>
              </p>
            </ng-container>
            <ng-container *ngIf="h.dataType !== 1 && h.dataType !== 4">
              <span>{{ d[h.value] }}</span>
            </ng-container>
            <ng-container *ngIf="h.dataType === 1">
              <span>{{ d[h.value] | date: h.dateFormat }}</span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="editRow(i)">
            <ng-container *ngIf="h.dataType === 0">
              <input [(ngModel)]="duped[h.value]" [name]="h.value" class="form-control"
                     type="text">
            </ng-container>
            <ng-container *ngIf="h.dataType === 1">
              <input [(ngModel)]="duped[h.value]" [name]="h.value" class="form-control"
                     type="date">
            </ng-container>
            <ng-container *ngIf="h.dataType === 2">
              <input [(ngModel)]="duped[h.value]" [name]="h.value" class="form-control"
                     type="number">
            </ng-container>
            <ng-container *ngIf="h.dataType === 3">
            <textarea [(ngModel)]="duped[h.value]" [name]="h.value"
                      class="form-control"></textarea>
            </ng-container>
            <ng-container *ngIf="h.dataType === 4">
              <p class="text-center">
              <span class="fa"
                    [ngClass]="{'fa-check-square-o':duped[h.value], 'fa-square-o':!duped[h.value]}"
                    (click)="toggleBoolean(duped, h.value)">&nbsp;</span>
              </p>
            </ng-container>
            <ng-container *ngIf="h.dataType === 5">
              <select [(ngModel)]="duped[h.value]" [name]="h.value" class="form-control">
                <option *ngFor="let o of h.dropdownValues" [value]="o">{{ o }}</option>
              </select>
            </ng-container>
          </ng-container>
        </td>
        <td *ngIf="showOptions()" class="options d-print-none" style="white-space: nowrap">
          <div *ngIf="editing !== i">
            <button-edit (btnClick)="edit(d,i)" *ngIf="showEdit" btnClass="me-1 btn-sm"></button-edit>
            <button-more (btnClick)="more(d)" *ngIf="showMore" btnClass="btn-sm"></button-more>
            <button-delete (btnClick)="del(d)" *ngIf="showDelete" btnClass="me-1 btn-sm"></button-delete>
          </div>
          <div *ngIf="editing === i">
            <button-save (btnClick)="save(duped)" btnClass="me-1 btn-sm"></button-save>
            <button-cancel (btnClick)="cancel()" btnClass="btn-sm"></button-cancel>
          </div>
        </td>
      </tr>
    </ng-container>
    </tbody>
    <!-- IF THE TABLE NEEDS TO ADD AS WELL -->
    <tfoot *ngIf="showAdd" [ngClass]="{'row-disabled':editing !== -1}" class="d-print-none">
    <tr>
      <th *ngIf="showCount" scope="row"></th>
      <td *ngFor="let h of headers">
        <input *ngIf="h.dataType === 0" [(ngModel)]="newValue[h.value]" [name]="h.value" class="form-control"
               type="text">
        <input *ngIf="h.dataType === 1" [(ngModel)]="newValue[h.value]" [name]="h.value" class="form-control"
               type="date">
        <input *ngIf="h.dataType === 2" [(ngModel)]="newValue[h.value]" [name]="h.value" class="form-control"
               type="number">
        <textarea *ngIf="h.dataType === 3" [(ngModel)]="newValue[h.value]" [name]="h.value"
                  class="form-control"></textarea>
        <p class="text-center" *ngIf="h.dataType === 4">
              <span class="fa"
                    [ngClass]="{'fa-check-square-o':newValue[h.value], 'fa-square-o':!newValue[h.value]}"
                    (click)="toggleBoolean(newValue, h.value)">&nbsp;</span>
        </p>
        <select *ngIf="h.dataType === 5" [(ngModel)]="newValue[h.value]" [name]="h.value" class="form-control">
          <option *ngFor="let o of h.dropdownValues" [value]="o">{{ o }}</option>
        </select>
      </td>
      <td *ngIf="showOptions()" class="options d-print-none" style="white-space: nowrap">
        <button-add (btnClick)="save(newValue)" btnClass="me-1 btn-sm"></button-add>
        <button-cancel (btnClick)="cancel()" btnClass="btn-sm"></button-cancel>
      </td>
    </tr>
    </tfoot>
  </table>
</form>
